import { useRef, useState } from 'react';
import type { Toast } from 'primereact/toast';
import { clearDownloadToast, showDownloadToast, showSuccessfullToast } from './exportToastHandler';

export function useExportToasts(minVisibleMs = 1200) {
  const downloadToastRef = useRef<Toast | null>(null);
  const successToastRef = useRef<Toast | null>(null);
  const [progress, setProgress] = useState(0);
  const [, setQueryNumber] = useState(0);
  const dummyIntervalRef = useRef<number | null>(null);
  const totalRef = useRef(0);
  const startedAtRef = useRef(0);

  const open = (total: number) => {
    totalRef.current = total;
    setQueryNumber(0);
    setProgress(0);
    showDownloadToast(downloadToastRef);
    startedAtRef.current = Date.now();
  };

  const tick = (delta = 1) => {
    setQueryNumber(prev => {
      const next = prev + delta;
      const pct = totalRef.current > 0 ? Math.round((next / totalRef.current) * 100) : 0;
      setProgress(Math.min(pct, 95));
      return next;
    });
  };

  const done = (after?: () => void) => {
    setProgress(100);
    const elapsed = Date.now() - startedAtRef.current;
    const wait = Math.max(minVisibleMs - elapsed, 0);
    setTimeout(() => {
      clearDownloadToast(setQueryNumber, setProgress, dummyIntervalRef, downloadToastRef);
      showSuccessfullToast(successToastRef);
      after?.();
    }, wait);
  };

  const clear = () => {
    clearDownloadToast(setQueryNumber, setProgress, dummyIntervalRef, downloadToastRef);
  };

  return {
    downloadToastRef,
    successToastRef,
    progress,
    open,
    tick,
    done,
    clear,
  };
}
